// extracted by mini-css-extract-plugin
export var page = "pageBooom-module--page--h5t2b";
export var gameContainer = "pageBooom-module--gameContainer--9NXpc";
export var game = "pageBooom-module--game--2OPaw";
export var lottie = "pageBooom-module--lottie--5uQ6w";